import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { AlertMessage } from '../AlertMessage';
import { ButtonBase } from '../Button';
import { Heading } from '../Heading';
import { HorizontalRule } from '../HorizontalRule';
import { Paragraph } from '../Paragraph';

export const StyledForm = styled('form')`
    display: flex;
    flex-direction: column;
`;

export const StyledPersonalDetailsWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            padding-top: ${theme.tggSpacing(rem(1), 2.5)};
        }
	`}
`;

export const StyledSmallText = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmall};
    ${({ theme }: { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(rem(1), 2.5)};
        margin: ${theme.tggSpacing(0, 0)};
        
	`}
`;

export const StyledSubmitButton = styled(ButtonBase)<{ maxwidth?: boolean }>`
    ${({ theme }) => theme.breakpoints.up('desktop')} {
        ${({ theme }: { theme: Theme }) => theme.typography.text_18_bold};
        ${({ theme, maxwidth }: { theme: Theme; maxwidth?: boolean }) => `
            ${!maxwidth && `max-width: ${theme.tggSpacing(rem(24), 60)};`}
	    `}
    }
`;

export const StyledSubmitButtonWrapper = styled('div')<{
    isRejoin: boolean;
}>`
    ${({ theme, isRejoin }: { theme: Theme; isRejoin: boolean }) => `
        display: flex;
        flex-direction: ${isRejoin ? 'column-reverse' : 'row'};
        gap: ${theme.tggSpacing(rem(2), 5)};
        align-items: ${isRejoin ? 'center' : 'flex-start'};
        justify-content: center;
        margin-top: ${theme.tggSpacing(rem(3), 7.5)};

        ${theme.breakpoints.up('desktop')} {
            margin-top: ${theme.tggSpacing(rem(4), 10)};
        }
	`}
`;

export const StyledAlertMessage = styled(AlertMessage)`
    ${({ theme }: { theme: Theme }) => `
        && {
            padding: ${theme.tggSpacing(rem(1.5), 3.75)};
        }
    `}
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(3), 0], [7.5, 0])};

        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing([rem(6), 0], [15, 0])};
        }
	`}
`;

export const StyledLink = styled('a')`
    ${({ theme }: { theme: Theme }) => `
    font-weight: bold;
    color: ${theme.palette.primary.dark};
    text-decoration: none;
    & :hover {
        color: ${theme.palette.primary.dark};
    }
`}
`;

export const StyledHeading = styled(Heading)`
    padding-left: 0;
    font-size: 2.1rem;
    text-align: left;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        font-size: 2.7rem;
        text-align: center;
    }
`;
